
import React, { useEffect, useState } from 'react';
import AdminManageDataUpload from '../../page-templates/admin/admin-manage-settings-data-upload';
import AttachmentLookupTable from './attachment-lookup-table';
import AttachmentDownloadCenter from './attachment-download-center';
import attachmentLookupService from '../../services/attachment-lookup-service';
import userService from '../../services/user-service';
import { useDispatch } from 'react-redux';
import { toast as toastAction } from '../../redux/actions/toasts-actions';
import * as XLSX from 'xlsx';

const AttachmentLookup = () => {
  const dispatch = useDispatch();
  const toast = (msg, type = 'success') => dispatch(toastAction(msg, type));


  // Download template Excel file with just "Voucher ID" header
  const handleDownloadTemplate = () => {
    // Create worksheet with header
    const worksheet = XLSX.utils.aoa_to_sheet([['Voucher ID']]);
    
    // Create workbook and add worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');
    
    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, 'attachment_lookup_template.xlsx');
    
    toast('Template file downloaded successfully', 'success');
  };

  // Config for reusing AdminManageDataUpload component
  const config = {
    title: 'Attachment Lookup',
    description: 'Upload a CSV or Excel file containing voucher IDs and/or deal IDs to retrieve attachment information.',
    uploadTitle: 'Upload File with Voucher/Deal IDs',
    uploadButtonText: 'Upload & Find Attachments',
    fileInputId: 'attachment-lookup',
    entityName: 'attachments',
    hideComparisonStats: true, // Don't show comparison statistics
    
    // Template download config
    templateDownload: {
      show: true,
      buttonText: 'Download Template File',
      onDownload: handleDownloadTemplate
    },
    
    // Upload service
    uploadService: async (file) => {
      try {
        const response = await attachmentLookupService.uploadAttachmentLookupFile(file);
        // Transform response to match AdminManageDataUpload expected format
        return {
          total_records: response.stats?.records_found || 0,
          new_count: 0,
          updated_count: 0,
          unchanged_count: response.stats?.records_found || 0,
          results: response.data || []
        };
      } catch (error) {
        return { error: error.message || 'Upload failed' };
      }
    },
    
    // Bulk update service (not used but required by component)
    bulkUpdateService: async () => {
      return { summary: { success_count: 0, created_count: 0, updated_count: 0 } };
    },
    
    // Comparison config
    comparisonConfig: {
      title: 'Retrieved Attachments',
      description: 'Review the attachments found for your voucher/deal IDs.',
    },
    
    // Custom right panel component for download center
    customRightPanel: <AttachmentDownloadCenter toast={toast} />
  };

  return (
    <AdminManageDataUpload 
      config={config}
      ComparisonTableComponent={AttachmentLookupTable}
      toast={toast}
    />
  );
};

export default AttachmentLookup;
